const enterFocus = (id) => {
  const element = document.getElementById(id);
  if (element) {
    return element.focus();
  }
};

export {enterFocus};